<template>
    <div class="program-view-wrapper pb20">
        <a-spin :spinning="spinning" tip="Loading...">
            <a-form :form="form">
                <!-- <a-form-item style="display:none;">
                    <a-input v-decorator="['id']"></a-input>
                </a-form-item> -->
                <a-form-item :label="$t('program.is_to_externally'/*日程是否对外显示*/)">
                    <a-radio-group v-decorator="['is_to_externally', { rules: [{ required: true, message: $t('program.choose_is_to_externally'/*请选择日程是否对外显示*/ ) }] }]">
                        <a-radio value="1">{{$t('program.open'/*是*/ )}}</a-radio>
                        <a-radio value="0">{{$t('program.close'/*否*/ )}}</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item :label="$t('program.program_abs_title_type'/*日程论文标题必填规则*/)">
                    <a-radio-group v-decorator="['program_abs_title_type', { rules: [{ required: true, message: $t('program.choose_program_abs_title_type'/*请选择日程论文标题必填规则*/ ) }] }]">
                        <a-radio value="1">{{$t('program.chinese_required'/*中文必填*/ )}}</a-radio>
                        <a-radio value="2">{{$t('program.english_required'/*英文必填*/ )}}</a-radio>
                        <a-radio value="3">{{$t('program.chinese_and_english_required'/*中英必填*/ )}}</a-radio>
                        <a-radio value="4">{{$t('program.chinese_and_english_only_one_required'/*中英只需填一个*/ )}}</a-radio>
                    </a-radio-group>
                </a-form-item>

                <a-form-item :label="$t('program.page_color_setting'/*日程页面颜色设置*/)">
                    <color-picker v-decorator="['page_color']"></color-picker>
                </a-form-item>
                <a-card size="small" :title="$t('program.pc_program_template'/*PC端日程模板*/)" class="mt20">
                    <a-form-item :label="$t('program.pc_program_template_selection'/*PC端日程模板选择*/)" class="mb10">
                        <a-input type="hidden" autocomplete="off" v-decorator="['pc_program_template']" />
                        <div class="template-content flex x-left flex-wrap y-center">
                            <div @click="() => form.setFieldsValue({pc_program_template:item.value})" v-for="(item, index) in pcProgramList" :key="index" :class="{ active: item.value == form.getFieldValue('pc_program_template') }" class="template-item mr20 mb20">
                                <a-popover placement="bottom">
                                    <template slot="content">
                                        <img style="width: 400px;" :src="item.template_img | urlFilter(750)" alt="" />
                                    </template>
                                    <img class="small-img" :src="item.template_img | urlFilter(250)" alt="" />
                                </a-popover>
                                <p class="t-c">{{item.title}}</p>
                            </div>
                        </div>
                    </a-form-item>

                    <a-form-item :label="$t('program.pc_program_list_template_selection'/*PC端日程一览表模板选择*/)" class="mt30">
                        <a-input type="hidden" autocomplete="off" v-decorator="['program_list_pc_type']" />
                        <div class="template-content flex x-left flex-wrap y-center">
                            <div @click="() => form.setFieldsValue({program_list_pc_type:item.value})" v-for="(item, index) in pcProgramBrowseList" :key="index" :class="{ active: item.value == form.getFieldValue('program_list_pc_type') }" class="template-item mr20 mb20">
                                <a-popover placement="bottom">
                                    <template slot="content">
                                        <img style="width: 400px;" :src="item.template_img | urlFilter(750)" alt="" />
                                    </template>
                                    <img class="small-img" :src="item.template_img | urlFilter(250)" alt="" />
                                </a-popover>
                                <p class="t-c">{{item.title}}</p>
                            </div>
                        </div>
                    </a-form-item>

                    <a-form-item :label="$t('program.pc_speaker_list_template_selection'/*PC端讲者列表模板选择*/)" class="mt30">
                        <a-input type="hidden" autocomplete="off" v-decorator="['speaker_temp_pc']" />
                        <div class="template-content flex x-left flex-wrap y-center">
                            <div @click="() => form.setFieldsValue({speaker_temp_pc:item.value})" v-for="(item, index) in pcSpeakerList" :key="index" :class="{ active: item.value == form.getFieldValue('speaker_temp_pc') }" class="template-item mr20 mb20">
                                <a-popover placement="bottom">
                                    <template slot="content">
                                        <img style="width: 400px;" :src="item.template_img | urlFilter(750)" alt="" />
                                    </template>
                                    <img class="small-img" :src="item.template_img | urlFilter(250)" alt="" />
                                </a-popover>
                                <p class="t-c">{{item.title}}</p>
                            </div>
                        </div>
                    </a-form-item>
                    
                    <div  class="mt30">
                        <a-row :gutter="[15, 15]">
                            <a-col :xxl="12" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-for="(item, index) in pcLinkList" :key="index">
                                <span>{{item.title}}</span>
                                <a :href="item.url" target="_blank">{{item.url}}</a>
                                <a-button class="ml5" type="primary" size="small" v-clipboard:copy="item.url" v-clipboard:success="copySuccess">{{$t('program.copy'/*复制*/ )}}</a-button>
                                <a :href="item.url" target="_blank">
                                    <a-button class="ml5" type="primary" size="small">{{$t('program.open'/*打开*/ )}}</a-button>
                                </a>
                            </a-col>
                        </a-row>
                    </div>
                </a-card>

                <a-card class="mt30" size="small" :title="$t('program.mobile_program_template'/*移动端日程模板*/)">
                    <a-form-item :label="$t('program.mobile_program_template_selection'/*移动端日程模板选择*/)" class="mb10">
                        <a-input type="hidden" autocomplete="off" v-decorator="['template_type']" />
                        <div class="template-content flex x-left flex-wrap y-center">
                            <div @click="() => form.setFieldsValue({template_type:item.value})" v-for="(item, index) in mProgramList" :key="index" :class="{ active: item.value == form.getFieldValue('template_type') }" class="template-item template-item-mobile mr20 mb20">
                                <a-popover placement="top">
                                    <template slot="content">
                                        <img style="width: 300px;" :src="item.template_img | urlFilter(750)" alt="" />
                                    </template>
                                    <img class="small-img" :src="item.template_img | urlFilter(250)" alt="" />
                                </a-popover>
                                <p class="t-c">{{item.title}}</p>
                            </div>
                        </div>
                    </a-form-item>

                    <a-form-item :label="$t('program.mobile_program_list_template_selection'/*移动端日程一览表模板选择*/)" class="mt30">
                        <a-input type="hidden" autocomplete="off" v-decorator="['program_list_type']" />
                        <div class="template-content flex x-left flex-wrap y-center">
                            <div @click="() => form.setFieldsValue({program_list_type:item.value})" v-for="(item, index) in mProgramBrowseList" :key="index" :class="{ active: item.value == form.getFieldValue('program_list_type') }" class="template-item template-item-mobile mr20 mb20">
                                <a-popover placement="top">
                                    <template slot="content">
                                        <img style="width: 300px;" :src="item.template_img | urlFilter(750)" alt="" />
                                    </template>
                                    <img class="small-img" :src="item.template_img | urlFilter(250)" alt="" />
                                </a-popover>
                                <p class="t-c">{{item.title}}</p>
                            </div>
                        </div>
                    </a-form-item>

                    <a-form-item :label="$t('program.mobile_speaker_list_template_selection'/*移动端讲者列表模板选择*/)" class="mt30">
                        <a-input type="hidden" autocomplete="off" v-decorator="['speaker_temp_h5']" />
                        <div class="template-content flex x-left flex-wrap y-center">
                            <div @click="() => form.setFieldsValue({speaker_temp_h5:item.value})" v-for="(item, index) in mSpeakerList" :key="index" :class="{ active: item.value == form.getFieldValue('speaker_temp_h5') }" class="template-item template-item-mobile mr20 mb20">
                                <a-popover placement="top">
                                    <template slot="content">
                                        <img style="width: 300px;" :src="item.template_img | urlFilter(750)" alt="" />
                                    </template>
                                    <img class="small-img" :src="item.template_img | urlFilter(250)" alt="" />
                                </a-popover>
                                <p class="t-c">{{item.title}}</p>
                            </div>
                        </div>
                    </a-form-item>

                    <div class="mt30">
                        <a-row :gutter="[15, 15]">
                            <a-col :xxl="12" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-for="(item, index) in mobileLinkList" :key="index">
                                <span>{{item.title}}</span>
                                <a :href="item.url" target="_blank">{{item.url}}</a>
                                <a-button class="ml5" type="primary" size="small" v-clipboard:copy="item.url" v-clipboard:success="copySuccess">{{$t('program.copy'/*复制*/ )}}</a-button>
                                <a :href="item.url" target="_blank">
                                    <a-button class="ml5" type="primary" size="small">{{$t('program.open'/*打开*/ )}}</a-button>
                                </a>
                            </a-col>
                        </a-row>
                    </div>
                </a-card>
                
                <a-card class="mt30">
                    <a-form-item class="mt10" :label="$t('program.select_program_content_to_display'/*请选择日程页面需要展示的内容*/)">
                        <div class="select-list">
                            <a-row :gutter="[15, 15]" type="flex">
                                <a-col :xxl="3" :xs="6" :sm="6" :md="6" :lg="6" :xl="6" v-for="(item, index) in programShowField" :key="index">
                                    <div :class="`select-item fs14 ${item.value == 1 ? 'select-item-active' : ''}`" @click="() => item.value = item.value == 1 ? 0 : 1">
                                        {{item.title}}
                                    </div>
                                </a-col>
                            </a-row>
                        </div>
                    </a-form-item>
                    <a-form-item :label="$t('program.whether_to_display_serial_number'/*是否显示编号*/)">
                        <a-radio-group v-decorator="['show_no_type', { rules: [{ required: true, message: $t('program.choose_whether_to_display_serial_number'/*请选择是否显示编号*/ ) }] }]">
                            <a-radio value="1">{{$t('program.display_paper_serial_number'/*显示论文编号*/ )}}</a-radio>
                            <a-radio value="0">{{$t('program.display_serial_number'/*显示序号*/ )}}</a-radio>
                            <a-radio value="-1">{{$t('program.do_not_display_serial_number'/*不显示编号*/ )}}</a-radio>
                        </a-radio-group>
                    </a-form-item>

                    <a-form-item :label="$t('program.program_display_order'/*日程展示顺序*/)">
                        <a-radio-group v-decorator="['is_program_model', { rules: [{ required: true, message: $t('program.choose_program_display_order'/*请选择日程展示顺序*/ ) }] }]">
                            <a-radio value="1">{{$t('program.display_by_hall_order'/*按会场顺序展示*/ )}}</a-radio>
                            <a-radio value="2">{{$t('program.display_by_date_order'/*按日期顺序展示*/ )}}</a-radio>
                            <a-radio value="3">{{$t('program.display_by_forum'/*按分论坛显示*/ )}}</a-radio>
                        </a-radio-group>
                    </a-form-item>

                    <a-form-item :label="$t('program.whether_to_display_chinese_and_english'/*是否显示中英文*/)">
                        <a-radio-group v-decorator="['show_two_title', { rules: [{ required: true, message: $t('program.choose_whether_to_display_chinese_and_english'/*请选择是否显示中英文*/ ) }] }]">
                            <a-radio value="0">{{$t('program.display_all'/*全部显示*/ )}}</a-radio>
                            <a-radio value="1">{{$t('program.display_only_chinese'/*只展示中文*/ )}}</a-radio>
                            <a-radio value="2">{{$t('program.display_only_english'/*只展示英文*/ )}}</a-radio>
                        </a-radio-group>
                    </a-form-item>

                    <a-form-item :label="$t('program.whether_to_display_english_page_local_time'/*英文页面是否展示 Local Time*/)">
                        <a-radio-group v-decorator="['show_two_title', { rules: [{ required: true, message: $t('program.choose_whether_to_display_english_page_local_time'/*请选择英文页面是否展示 Local Time*/ ) }] }]">
                            <a-radio value="1">{{$t('program.open'/*是*/ )}}</a-radio>
                            <a-radio value="2">{{$t('program.close'/*否*/ )}}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-card>

                <a-card class="mt30" :title="$t('program.speaker_host_configuration'/*讲者主持配置*/)">
                    <a-form-item :label="$t('program.speaker_host_list_display_order'/*讲者主持列表显示顺序*/)">
                        <a-radio-group v-decorator="['speaker_contact', { rules: [{ required: true, message: $t('program.choose_speaker_host_list_display_order'/*请选择讲者主持列表显示顺序*/ ) }] }]">
                            <a-radio value="1">{{$t('program.sort_by_pinyin_order'/*按照姓名拼音顺序排序*/ )}}</a-radio>
                            <a-radio value="2">{{$t('program.sort_by_program_order'/*按照日程出场顺序排序*/ )}}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item :label="$t('program.whether_to_display_avatar'/*是否显示头像*/)">
                        <a-radio-group v-decorator="['is_avatar', { rules: [{ required: true, message: $t('program.choose_whether_to_display_avatar'/*请选择是否显示头像*/ ) }] }]">
                            <a-radio value="1">{{$t('program.open'/*是*/ )}}</a-radio>
                            <a-radio value="0">{{$t('program.close'/*否*/ )}}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item :label="$t('program.whether_to_display_personal_introduction'/*是否显示个人简介*/)">
                        <a-radio-group v-decorator="['is_display_resume', { rules: [{ required: true, message: $t('program.choose_whether_to_display_personal_introduction'/*请选择是否显示个人简介*/ ) }] }]">
                            <a-radio value="1">{{$t('program.open'/*是*/ )}}</a-radio>
                            <a-radio value="0">{{$t('program.close'/*否*/ )}}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item :label="$t('program.whether_to_display_speaker_host_query_page_statistics'/*是否显示讲者主持查询页面统计数*/)">
                        <a-radio-group v-decorator="['is_display_jz_num', { rules: [{ required: true, message: $t('program.choose_whether_to_display_speaker_host_query_page_statistics'/*请选择是否显示讲者主持查询页面统计数*/ ) }] }]">
                            <a-radio value="1">{{$t('program.open'/*是*/ )}}</a-radio>
                            <a-radio value="0">{{$t('program.close'/*否*/ )}}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item :label="$t('program.whether_to_display_acceptance_state_in_backend_program_management_page'/*后台日程管理页面是否显示接受状态*/)">
                        <a-radio-group v-decorator="['open_acceptance_state', { rules: [{ required: true, message: $t('program.choose_whether_to_display_acceptance_state_in_backend_program_management_page'/*请选择后台日程管理页面是否显示接受状态*/ ) }] }]">
                            <a-radio value="1">{{$t('program.open'/*是*/ )}}</a-radio>
                            <a-radio value="0">{{$t('program.close'/*否*/ )}}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item :label="$t('program.whether_to_allow_experts_to_jump_to_expert_personal_center_from_conference_program_details'/*是否允许会议日程详情点击专家姓名跳转到专家个人中心*/)">
                        <a-radio-group v-decorator="['is_jump_user_info', { rules: [{ required: true, message: $t('program.choose_whether_to_allow_experts_to_jump_to_expert_personal_center_from_conference_program_details'/*请选择是否允许会议日程详情点击专家姓名跳转到专家个人中心*/ ) }] }]">
                            <a-radio value="1">{{$t('program.open'/*是*/ )}}</a-radio>
                            <a-radio value="0">{{$t('program.close'/*否*/ )}}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item :label="$t('program.whether_to_enable_academic_task_sheet_download'/*是否开启学术任务单下载*/)">
                        <a-radio-group v-decorator="['is_travel_itinerary', { rules: [{ required: true, message: $t('program.choose_whether_to_enable_academic_task_sheet_download'/*请选择是否开启学术任务单下载*/ ) }] }]">
                            <a-radio value="1">{{$t('program.open'/*是*/ )}}</a-radio>
                            <a-radio value="0">{{$t('program.close'/*否*/ )}}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item :label="$t('program.whether_to_include_system_hidden_session_program_in_academic_task_confirmation_and_sms_email_reminder'/*个人学术任务确认、短信邮件发送温馨提示时是否需要包含系统隐藏的SESSION日程*/)">
                        <a-radio-group v-decorator="['is_display_program_send', { rules: [{ required: true, message: $t('program.choose_whether_to_include_system_hidden_session_program_in_academic_task_confirmation_and_sms_email_reminder'/*请选择个人学术任务确认、短信邮件发送温馨提示时是否需要包含系统隐藏的SESSION日程*/ ) }] }]">
                            <a-radio value="1">{{$t('program.open'/*是*/ )}}</a-radio>
                            <a-radio value="0">{{$t('program.close'/*否*/ )}}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-card>

                <a-card class="mt30" :title="$t('program.session_subscription'/*Session订阅*/)">
                    <a-button type="primary" @click="$refs.subscribeModalRef.showFun(1)">{{$t('program.view_session_subscription_record'/*查看Session订阅记录*/ )}}</a-button>
                    <a-form-item :label="$t('program.whether_to_session_subscription'/*是否Session订阅*/)">
                        <a-radio-group v-decorator="['remind_participant', { rules: [{ required: true, message: $t('program.choose_whether_to_session_subscription'/*请选择是否Session订阅*/ ) }] }]">
                            <a-radio value="1">{{$t('program.open'/*是*/ )}}</a-radio>
                            <a-radio value="0">{{$t('program.close'/*否*/ )}}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <div v-show="form.getFieldValue('remind_participant') == 1">
                        <a-form-item :label="$t('program.whether_to_send_reminder_sms'/*是否发送提醒短信*/)">
                            <a-radio-group v-decorator="['remind_is_send_sms', { rules: [{ required: form.getFieldValue('remind_participant') == 1, message: $t('program.choose_whether_to_send_reminder_sms'/*请选择是否发送提醒短信*/ ) }] }]">
                                <a-radio value="1">{{$t('program.open'/*是*/ )}}</a-radio>
                                <a-radio value="0">{{$t('program.close'/*否*/ )}}</a-radio>
                            </a-radio-group>
                            <template slot="extra">
                                <p style="color:red;">{{$t('program.this_function_will_deduct_meeting_creator_sms_balance'/*此功能会扣除会议创建者短信发送余额，提醒的日程必须在当前会议配置区间内，推送任务会提前生成，如需测试请在开始前时间上再加五分钟，避免里测试时间过近测试失败*/ )}}</p>
                            </template>
                        </a-form-item>
                        <a-form-item :label="$t('program.conference_representative_session_reminder_send_time'/*参会代表Session提醒发送时间*/)">
                            <span class="mr5">{{$t('program.before_program_start'/*日程开始前*/ )}}</span>
                            <a-input-number :min="0" v-decorator="['remind_participant_time', { rules: [{ required: form.getFieldValue('remind_participant') == 1, message: $t('program.please_enter_conference_representative_session_reminder_send_time'/*请输入参会代表Session提醒发送时间*/ ) }] }]"></a-input-number>
                            <span class="ml5">{{$t('program.minutes_before_sending_reminder'/*分钟前发出提醒*/ )}}</span>
                            <a-button type="primary" class="ml10" @click="$refs.smsHistoryModalRef.showFun(1)">{{$t('program.view_sms_send_record'/*查看短信发送记录*/ )}}</a-button>
                        </a-form-item>
                        <a-form-item :label="$t('program.conference_representative_session_reminder_content'/*参会代表Session提醒内容*/)">
                            <a-select placeholder="请选择系统字段" @change="(value) => handleFieldEvent(value, 'remind_participant_content')">
                                <a-select-option value="{real_name}">{{$t('program.conference_representative_name'/*参会者姓名*/ )}}</a-select-option>
                                <a-select-option value="{spekers}">{{$t('program.speaker_name'/*讲者姓名*/ )}}</a-select-option>
                                <a-select-option value="{abstract_title}">{{$t('program.speech_title'/*发言题目*/ )}}</a-select-option>
                                <a-select-option value="{starttime_slot}">{{$t('program.speech_time'/*发言时间*/ )}}</a-select-option>
                                <a-select-option value="{meeting_hall}">{{$t('program.meeting_hall'/*会场名称*/ )}}</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item>
                            <a-textarea style="height:120px;" v-decorator="['remind_participant_content', { rules: [{ required: form.getFieldValue('remind_participant') == 1, message: $t('program.please_choose_conference_representative_session_reminder_content'/*请选择参会代表Session提醒内容*/ ) }] }]"></a-textarea>
                            <template slot="extra">
                                <p style="color:#red;">{{$t('program.the_longest_character_length_of_a_single_sms_content_is_500_characters'/*一次发放短信内容的最长字符数不超过500字符*/ )}}</p>
                            </template>
                        </a-form-item>
                    </div>
                </a-card>


                <a-card class="mt30" :title="$t('program.program_subscription'/*日程订阅*/)">
                    <a-button type="primary" @click="$refs.subscribeModalRef.showFun(2)">{{$t('program.view_program_subscription_record'/*查看日程订阅记录*/ )}}</a-button>
                    <a-form-item :label="$t('program.whether_to_program_subscription'/*是否日程订阅*/)">
                        <a-radio-group v-decorator="['remind_participan_p', { rules: [{ required: true, message: $t('program.choose_whether_to_program_subscription'/*请选择是否日程订阅*/ ) }] }]">
                            <a-radio value="1">{{$t('program.open'/*是*/ )}}</a-radio>
                            <a-radio value="0">{{$t('program.close'/*否*/ )}}</a-radio>
                        </a-radio-group>
                    </a-form-item>
                    <div v-show="form.getFieldValue('remind_participan_p') == 1">
                        <a-form-item :label="$t('program.whether_to_send_reminder_sms'/*是否发送提醒短信*/)">
                            <a-radio-group v-decorator="['remind_is_send_sms_p', { rules: [{ required: form.getFieldValue('remind_participan_p') == 1, message: $t('program.choose_whether_to_send_reminder_sms'/*请选择是否发送提醒短信*/ ) }] }]">
                                <a-radio value="1">{{$t('program.open'/*是*/ )}}</a-radio>
                                <a-radio value="0">{{$t('program.close'/*否*/ )}}</a-radio>
                            </a-radio-group>
                            <template slot="extra">
                                <p style="color:red;">{{$t('program.this_function_will_deduct_meeting_creator_sms_balance'/*此功能会扣除会议创建者短信发送余额，提醒的日程必须在当前会议配置区间内，推送任务会提前生成，如需测试请在开始前时间上再加五分钟，避免里测试时间过近测试失败*/ )}}</p>
                            </template>
                        </a-form-item>
                        <a-form-item :label="$t('program.conference_representative_program_reminder_send_time'/*参会代表日程提醒发送时间*/)">
                            <span class="mr5">{{$t('program.before_program_start'/*日程开始前*/ )}}</span>
                            <a-input-number :min="0" v-decorator="['remind_participant_time_p', { rules: [{ required: form.getFieldValue('remind_participan_p') == 1, message: $t('program.please_enter_conference_representative_program_reminder_send_time'/*请输入参会代表日程提醒发送时间*/ ) }] }]"></a-input-number>
                            <span class="ml5">{{$t('program.minutes_before_sending_reminder'/*分钟前发出提醒*/ )}}</span>
                            <a-button type="primary" class="ml10" @click="$refs.smsHistoryModalRef.showFun(3)">{{$t('program.view_sms_send_record'/*查看短信发送记录*/ )}}</a-button>
                        </a-form-item>
                        <a-form-item :label="$t('program.conference_representative_session_reminder_content'/*参会代表Session提醒内容*/)">
                            <a-select placeholder="请选择系统字段" @change="(value) => handleFieldEvent(value, 'remind_participant_content_p')">
                                <a-select-option value="{real_name}">{{$t('program.conference_representative_name'/*参会者姓名*/ )}}</a-select-option>
                                <a-select-option value="{spekers}">{{$t('program.speaker_name'/*讲者姓名*/ )}}</a-select-option>
                                <a-select-option value="{abstract_title}">{{$t('program.speech_title'/*发言题目*/ )}}</a-select-option>
                                <a-select-option value="{starttime_slot}">{{$t('program.speech_time'/*发言时间*/ )}}</a-select-option>
                                <a-select-option value="{meeting_hall}">{{$t('program.meeting_hall'/*会场名称*/ )}}</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item>
                            <a-textarea style="height:120px;" v-decorator="['remind_participant_content_p', { rules: [{ required: form.getFieldValue('remind_participan_p') == 1, message: $t('program.please_choose_conference_representative_session_reminder_content'/*请选择参会代表Session提醒内容*/ ) }] }]"></a-textarea>
                            <template slot="extra">
                                <p style="color:red;">{{$t('program.the_longest_character_length_of_a_single_sms_content_is_500_characters'/*一次发放短信内容的最长字符数不超过500字符*/ )}}</p>
                            </template>
                        </a-form-item>
                    </div>
                </a-card>

                <a-card class="mt30" :title="$t('program.host_and_speaker_program_reminder'/*主持人、发言人日程提醒*/)">
                    <a-form-item :label="$t('program.whether_to_enable_host_and_speaker_program_reminder'/*是否开启主持人、发言人日程提醒*/)">
                        <a-radio-group v-decorator="['remind_faculty', { rules: [{ required: true, message: $t('program.choose_whether_to_enable_host_and_speaker_program_reminder'/*请选择是否日程订阅*/ ) }] }]">
                            <a-radio value="1">{{$t('program.open'/*是*/ )}}</a-radio>
                            <a-radio value="0">{{$t('program.close'/*否*/ )}}</a-radio>
                        </a-radio-group>
                        <template slot="extra">
                            <p style="color:red;">{{$t('program.this_function_will_deduct_meeting_creator_sms_balance'/*此功能会扣除会议创建者短信发送余额，提醒的日程必须在当前会议配置区间内，推送任务会提前生成，如需测试请在开始前时间上再加五分钟，避免里测试时间过近测试失败*/ )}}</p>
                        </template>
                    </a-form-item>
                    <div v-show="form.getFieldValue('remind_faculty') == 1">
                        <a-form-item :label="$t('program.conference_representative_program_reminder_send_time'/*参会代表日程提醒发送时间*/)">
                            <span class="mr5">{{$t('program.before_program_start'/*日程开始前*/ )}}</span>
                            <a-input-number :min="0" v-decorator="['remind_faculty_time', { rules: [{ required: form.getFieldValue('remind_faculty') == 1, message: $t('program.please_enter_conference_representative_program_reminder_send_time'/*请输入参会代表日程提醒发送时间*/ ) }] }]"></a-input-number>
                            <span class="ml5">{{$t('program.minutes_before_sending_reminder'/*分钟前发出提醒*/ )}}</span>
                            <a-button type="primary" class="ml10" @click="$refs.smsHistoryModalRef.showFun(2)">{{$t('program.view_sms_send_record'/*查看短信发送记录*/ )}}</a-button>
                        </a-form-item>
                        <a-form-item :label="$t('program.conference_representative_session_reminder_content'/*参会代表Session提醒内容*/)">
                            <a-select placeholder="请选择系统字段" @change="(value) => handleFieldEvent(value, 'remind_faculty_content')">
                                <a-select-option value="{real_name}">{{$t('program.conference_representative_name'/*参会者姓名*/ )}}</a-select-option>
                                <a-select-option value="{spekers}">{{$t('program.speaker_name'/*讲者姓名*/ )}}</a-select-option>
                                <a-select-option value="{abstract_title}">{{$t('program.speech_title'/*发言题目*/ )}}</a-select-option>
                                <a-select-option value="{starttime_slot}">{{$t('program.speech_time'/*发言时间*/ )}}</a-select-option>
                                <a-select-option value="{meeting_hall}">{{$t('program.meeting_hall'/*会场名称*/ )}}</a-select-option>
                            </a-select>
                        </a-form-item>
                        <a-form-item>
                            <a-textarea style="height:120px;" v-decorator="['remind_faculty_content', { rules: [{ required: form.getFieldValue('remind_faculty') == 1, message: $t('program.please_choose_conference_representative_session_reminder_content'/*请选择参会代表Session提醒内容*/ ) }] }]"></a-textarea>
                            <template slot="extra">
                                <p style="color:#red;">{{$t('program.the_longest_character_length_of_a_single_sms_content_is_500_characters'/*一次发放短信内容的最长字符数不超过500字符*/ )}}</p>
                            </template>
                        </a-form-item>
                    </div>
                </a-card>
            </a-form>
            <div class="t-c mt20">
                <a-button style="width:200px" type="primary" @click="handleSubmitEvent">{{$t('program.save'/*保存*/ )}}</a-button>
            </div>
        </a-spin>
        <subscribe-modal ref="subscribeModalRef"/>
        <sms-history-modal ref="smsHistoryModalRef"/>
    </div>
</template>
<script>
import pick from 'lodash.pick';
import subscribeModal from './components/subscribe-modal.vue'
import smsHistoryModal from './components/sms-history-modal.vue'
const fileds = ['is_to_externally', 'program_abs_title_type', 'page_color', 'pc_program_template',
'program_list_pc_type', 'speaker_temp_pc', 'template_type', 'program_list_type', 'speaker_temp_h5',
'show_no_type', 'is_program_model', 'show_two_title', 'show_local_time', 'speaker_contact',
'is_avatar', 'is_display_resume', 'is_display_jz_num', 'open_acceptance_state', 'is_jump_user_info',
'is_travel_itinerary', 'is_display_program_send', 'remind_participant', 'remind_is_send_sms',
'remind_participant_time', 'remind_participant_content',  'remind_participan_p', 'remind_is_send_sms_p',
'remind_participant_time_p', 'remind_participant_content_p', 'remind_faculty', 'remind_faculty_time',
'remind_faculty_content'];
import ColorPicker from '@/components/ColorPicker'
export default {
    name: 'editSpeakModal',
    components: {
        ColorPicker,
        subscribeModal,
        smsHistoryModal
    },
    data() {
        return {
            visible: false,
            confirmLoading: false,
            form: this.$form.createForm(this),
            programConfig: {},
            pcProgramList: [ // pc日程模板
                {
                    template_img: 'https://files.sciconf.cn/asset/images/program-config/pc-program-temp1.jpg',
                    value: 1,
                    title: this.$t('program.pcProgramList1')// 日程模板一
                },
                {
                    template_img: 'https://files.sciconf.cn/asset/images/program-config/pc-program-temp2.jpg',
                    value: 2,
                    title: this.$t('program.pcProgramList2')// 日程模板二
                }
            ],
            pcProgramBrowseList: [ // pc日程一览表
                {
                    template_img: 'https://files.sciconf.cn/asset/images/program-config/pc-program-preview-temp1.jpg',
                    value: 0,
                    title: '日程一览模板一'
                },
                {
                    template_img: 'https://files.sciconf.cn/asset/images/program-config/pc-program-preview-temp2.jpg',
                    value: 1,
                    title: '日程一览模板二'
                },
                {
                    template_img: 'https://files.sciconf.cn/asset/images/program-config/pc-program-preview-temp3.jpg',
                    value: 2,
                    title: '日程一览模板三'
                },
                {
                    template_img: 'https://files.sciconf.cn/asset/images/program-config/pc-program-preview-temp4.jpg',
                    value: 3,
                    title: '日程一览模板四'
                },
                {
                    template_img: 'https://files.sciconf.cn/asset/images/program-config/pc-program-preview-temp5.jpg',
                    value: 4,
                    title: '日程一览模板五'
                },
                {
                    template_img: 'https://files.sciconf.cn/asset/images/program-config/pc-program-preview-temp5.jpg',
                    value: 5,
                    title: '日程一览模板六（按分论坛展示）'
                },
            ],
            pcSpeakerList: [ // pc讲者模板列表
                {
                    template_img: 'https://files.sciconf.cn/pdf/2025/speaker_pc_1.jpg!wx250',
                    value: 1,
                    title: '讲者列表模板一'
                },
                {
                    template_img: 'https://files.sciconf.cn/pdf/2025/speaker_pc_2.jpg!wx250',
                    value: 2,
                    title: '讲者列表模板二'
                },
                {
                    template_img: 'https://files.sciconf.cn/pdf/2025/speaker_pc_3.jpg!wx250',
                    value: 3,
                    title: '讲者列表模板三'
                },
                {
                    template_img: 'https://files.sciconf.cn/pdf/2025/speaker_pc_4.jpg!wx250',
                    value: 4,
                    title: '讲者列表模板四'
                },
            ],
            pcLinkList: [ // pc链接
                {
                    title: 'PC端日程（中文）',
                    url: `https://medcon.sciconf.cn/cn/web/program/${this.$route.params.meeting_id}`
                },
                {
                    title: 'PC端日程一览（中文）',
                    url: `https://medcon.sciconf.cn/cn/web/program-view/${this.$route.params.meeting_id}`
                },
                {
                    title: 'PC端日程（英文）',
                    url: `https://medcon.sciconf.cn/en/web/program/${this.$route.params.meeting_id}`
                },
                
                {
                    title: 'PC端日程一览（英文）',
                    url: `https://medcon.sciconf.cn/en/web/program-view/${this.$route.params.meeting_id}`
                },
            ],

            mProgramList: [ // 移动端日程模板
                {
                    template_img: 'https://files.sciconf.cn/asset/images/program-config/wap-program-temp1.jpg',
                    value: 1,
                    title: '移动端日程模板一'
                },
                {
                    template_img: 'https://files.sciconf.cn/asset/images/program-config/wap-program-temp2.jpg',
                    value: 2,
                    title: '移动端日程模板二'
                },
                {
                    template_img: 'https://files.sciconf.cn/asset/images/program-config/wap-program-temp3.jpg',
                    value: 3,
                    title: '移动端日程模板三'
                },
                {
                    template_img: 'https://files.sciconf.cn/asset/images/program-config/wap-program-temp0.jpg',
                    value: 4,
                    title: '移动端日程模板四'
                },
                {
                    template_img: 'https://files.sciconf.cn/asset/images/program-config/wap-program-preview-temp5.jpg?v=1',
                    value: 5,
                    title: '移动端日程模板五'
                }
            ],
            mProgramBrowseList: [ // 移动端日程一览表
                {
                    template_img: 'https://files.sciconf.cn/asset/images/program-config/wap-program-preview-temp1.jpg',
                    value: 0,
                    title: '日程一览模板一'
                },
                {
                    template_img: '	https://files.sciconf.cn/asset/images/program-config/wap-program-preview-temp2.jpg',
                    value: 2,
                    title: '日程一览模板二'
                },
                {
                    template_img: 'https://files.sciconf.cn/asset/images/program-config/wap-program-preview-temp3.jpg',
                    value: 1,
                    title: '日程一览模板三'
                },
            ],
            mSpeakerList: [ // 移动端讲者模板列表
                {
                    template_img: 'https://files.sciconf.cn/pdf/2025/speaker_h5_1.jpg!wx250',
                    value: 1,
                    title: '讲者列表模板一'
                },
                {
                    template_img: 'https://files.sciconf.cn/pdf/2025/speaker_h5_2.jpg!wx250',
                    value: 2,
                    title: '讲者列表模板二'
                },
                {
                    template_img: 'https://files.sciconf.cn/pdf/2025/speaker_h5_3.jpg!wx250',
                    value: 3,
                    title: '讲者列表模板三'
                },
                {
                    template_img: 'https://files.sciconf.cn/pdf/2025/speaker_h5_4.jpg!wx250',
                    value: 4,
                    title: '讲者列表模板四'
                },
            ],
            mobileLinkList: [ // 移动端链接
                {
                    title: '移动端日程（中文）',
                    url: ` https://zgyyyzdh.sciconf.cn/cn/minisite/program/${this.$route.params.meeting_id}`
                },
                {
                    title: '移动端日程一览（中文）',
                    url: ` https://zgyyyzdh.sciconf.cn/cn/minisite/program-view/${this.$route.params.meeting_id}`
                },
                {
                    title: '移动端日程（英文）',
                    url: ` https://zgyyyzdh.sciconf.cn/en/minisite/program/${this.$route.params.meeting_id}`
                },
                
                {
                    title: '移动端日程一览（英文）',
                    url: ` https://zgyyyzdh.sciconf.cn/en/minisite/program-view/${this.$route.params.meeting_id}`
                },
            ],
            // 日程页面需要展示的内容
            programShowField: [
                {
                    field: 'show_orgname_zhuchi',
                    title: '主持人单位',
                    value: ''
                },
                {
                    field: 'show_orgname_fayan',
                    title: '讲者单位',
                    value: ''
                },
                {
                    field: 'show_type',
                    title: '发言类型',
                    value: ''
                },
                {
                    field: 'different_country',
                    title: '国别',
                    value: ''
                },
                {
                    field: 'teach_title',
                    title: '职称',
                    value: ''
                },
                {
                    field: 'post_name',
                    title: '职务',
                    value: ''
                },
                {
                    field: 'is_program_video',
                    title: '关联日程视频按钮',
                    value: ''
                },
                {
                    field: 'open_live_button',
                    title: '关联Session直播按钮',
                    value: ''
                },
            ],
            spinning: false
        };
    },
    methods: {
        handleFieldEvent (value, field) {
            console.log(field)
            let textarea = this.form.getFieldValue(field)
            let obj = {}
            obj[field] = textarea + value
            this.form.setFieldsValue(obj)
        },
        getProgramConfig () {
            this.spinning = true
            this.$request.get({ url: 'getProgramConfig' }).then((res) => {
                const { code, data } = res
                this.programConfig = data
                this.form.setFieldsValue(pick(data, fileds))
                this.programShowField.forEach((item, index) => {
                    item.value = data[item.field]
                })
            }).finally(() => {
                this.spinning = false
            })
        },
         /**
         * 复制链接
         */
        copySuccess() {
            this.$message.success(this.$t('web.copy_success') /* 复制成功 */);
        },
        handleSubmitEvent () {
            this.spinning = true
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.programShowField.forEach((item, index) => {
                        values[item.field] = item.value
                    })
                    this.$request.post({ url: 'setProgramConfig', data: { ...values } }).then((res) => {
                        this.$message.success(this.$t('user.save_success')/* 保存成功 */)
                    }).finally(() => {
                        this.spinning = false
                    })
                }
            })
        },
    },
    created () {
        fileds.forEach(v => this.form.getFieldDecorator(v))
    },
    mounted () {
        this.getProgramConfig()
    }
};
</script>
<style lang="less" scoped>
.template-content {
    .template-item {
        width: 150px;
        height: 122px;
        cursor: pointer;
        position: relative;
        border: 1px solid @border-color;
        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center top;
        }
        &.active {
            position: relative;
            &:before {
                content: '\ed1d';
                font-family: 'medcon';
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.7);
                position: absolute;
                color: #ffffff;
                z-index: 6;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 40px;
                font-weight: bold;
            }
        }
    }
    .template-item-mobile {
        width: 150px;
        height: 296px !important;
    }
}
:deep(.ant-card-head) {
    background: #fafafa;
    .ant-card-head-title {
        font-weight: bold;
    }
}
.select-list {
    .select-item {
        border: solid 1px #c9c9c9;
        width: 100%;
        box-sizing: border-box;
        cursor: pointer;
        text-align: center;
    }
    .select-item-active {
        border: 1px solid #4d9ff8;
        position: relative;
        background: #f0f8ff;
        &:after {
            content: '';
            position: absolute;
            width: 100%;
            height: 100%;
            background: url(https://files.sciconf.cn/asset/images/select-icon.png) no-repeat right bottom;
            background-size: 20px;
            top: 0;
            left: 0;
            z-index: 1;
        }
    }
}
</style>